import gql from "graphql-tag";

export const FTTB_ADD_ADDRESS_TO_WAITING_LIST = gql`
    mutation fttbAddAddressToWaitingList($details: AddressToWaitingList!) {
            fttb_add_address_to_waiting_list(details: $details) {
    requestId
       }
    }
`;
